/*
 * Ryan O'Dowd
 * 2025-05-26
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import {
  Platform,
} from 'react-native';
import globals from '@utils/globals';
import useTypedSelector from './useTypedSelector';

export default function useIsAdmin() {
  return useTypedSelector((state) => {
    if (Platform.OS === 'web' && sessionStorage.getItem('masqueradeAsUserId')) {
      return false;
    }

    return globals.adminAuthIds.includes(state.oakUser?.auth_id);
  });
}
